import $ from 'jquery';
import { Utility } from 'App/track/analytics/util';
import { Universal } from 'App/track/analytics/universal';

var preloadEvents = window._trackPreloadEvents;

var selectors = {

};

var Preload = {
	init: function () {
		// console.log( 'Track Preload Init' );

		Preload = this;

		var preloadEvents = window._trackPreloadEvents;

		if (typeof preloadEvents != 'undefined' && preloadEvents.length) {
			for (var i = 0; i < preloadEvents.length; i++) {
				var data = preloadEvents[i];

				Utility.publishEvent(data);
			}
		}
	}
};

export { Preload };